export default __webpack_public_path__ + "static/media/previous_history.8dd8b2cd.svg";